import React from 'react';
import {CustomDialog, Dialog} from '@wix/wix-ui-tpa/cssVars';
import {useEnvironment, useExperiments} from '@wix/yoshi-flow-editor';
import {classes, st} from './EcomDialog.st.css';
import {SPECS} from '../../constants';

type DialogProps = React.ComponentProps<typeof Dialog>;
type CustomDialogProps = React.ComponentProps<typeof CustomDialog>;

function useShouldAddHackClassNameForClassicMobilePreview(): boolean {
  const {isMobile, isPreview} = useEnvironment();
  const {experiments} = useExperiments();
  return experiments.enabled(SPECS.ShowCheckoutOnEditorPreview) && isMobile && isPreview;
}

export function EcomDialog(props: DialogProps): React.ReactElement {
  const {className, ...rest} = props;
  const shouldAddHackClassNameForClassicMobilePreview = useShouldAddHackClassNameForClassicMobilePreview();

  return (
    <Dialog
      {...rest}
      className={
        shouldAddHackClassNameForClassicMobilePreview ? st(className, classes.hackForClassicMobilePreview) : className
      }
    />
  );
}

export function EcomCustomDialog(props: CustomDialogProps): React.ReactElement {
  const {className, ...rest} = props;
  const shouldAddHackClassNameForClassicMobilePreview = useShouldAddHackClassNameForClassicMobilePreview();
  return (
    <CustomDialog
      {...rest}
      className={
        shouldAddHackClassNameForClassicMobilePreview ? st(className, classes.hackForClassicMobilePreview) : className
      }
    />
  );
}
